






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class DynamicVisibilityContainer extends Vue {
    @Prop(String)
    public idOfCheckbox!: string;
    private showSlotContent: boolean = false;

    protected mounted(): void {
        const checkboxElement = document.getElementById(this.idOfCheckbox) as HTMLInputElement;
        if (checkboxElement) {
            checkboxElement.addEventListener('change', this.onCheckboxStateChanged);
            this.toggleSlotContentVisibility(checkboxElement.checked);
        }
    }

    private onCheckboxStateChanged(event: Event): void {
        const checkboxElement = event.target as HTMLInputElement;
        if (checkboxElement) {
            this.toggleSlotContentVisibility(checkboxElement.checked);
        }
    }

    private toggleSlotContentVisibility(show: boolean): void {
        this.showSlotContent = show;
    }
}
